module.exports = __webpack_public_path__ + "media/images/icon/search-activity-4494b0086a89e1ac869ab9467159827f.svg";